import { useSegment, useLaunchDarkly } from 'studio5/hooks/preconditions';

const Preconditions = () => {
  useSegment();
  useLaunchDarkly();

  return null;
};

export default Preconditions;
